import React, {Fragment} from 'react';
import {ConnectedRouter} from 'react-router-redux'
import {IntlProvider} from "react-intl";
import {reduxHistory} from "./store";
import {setLanguage} from "./actions/app";
import {connect} from "react-redux";
import Header from './components/Header';
import Content from './Content';
import Footer from './components/Footer';
import MessageAlert from './components/MessageAlert';
import {languages} from "./languages";
import './styles/style';
import MessageModal from "./components/MessageModal";
import SellModal from "./components/SellModal";
import StepModal from "./components/StepModal"


class MainWrap extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            languages: languages
        };
    }

    componentDidMount() {
    }

    render() {
        let {activeLanguage} = this.props;

        let {languages} = this.state;
        return (
            languages && <IntlProvider locale={activeLanguage} messages={languages[activeLanguage]}>
                <ConnectedRouter history={reduxHistory}>
                    <Fragment>
                        <Header/>
                        <Content/>
                        <Footer/>
                        <MessageAlert activeLanguage={activeLanguage}/>
                        <MessageModal activeLanguage={activeLanguage}/>
                        <SellModal activeLanguage={activeLanguage} />
                    </Fragment>
                </ConnectedRouter>
            </IntlProvider>
        );
    }
}

function mapStateToProps(state) {
    return {
        activeLanguage: state.app.activeLanguage,
        router: state.router,
    };
}

const mapDispatchToProps = {
    setLanguage
};

export default connect(mapStateToProps, mapDispatchToProps)(MainWrap)
